import styled from 'styled-components/macro';
import { DefaultButton } from 'components';
import { BREAKPOINTS } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { BaseContentContainer } from 'utils/baseElements';
import { Section } from '../core/elemetns';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import Slider from 'react-slick';

export const StyledClientsFeedbackSection = styled(Section)`
  height: 680px;
  position: relative;
  z-index: 1;

  & * {
    color: ${COLORS.mainColor};
  }

  @media ${BREAKPOINTS.lg} {
    height: 620px;
  }

  @media ${BREAKPOINTS.md} {
    height: 580px;
  }

  @media ${BREAKPOINTS.sm} {
    height: 550px;
  }
`;

export const StyledSlider = styled(Slider)`
  .slick-current .slider-item-image {
    transform: scale(1.6);
  }
`;

export const SliderSectionTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  text-align:center;
  padding-bottom: 20px;
  padding-top: 20px;
`;

export const SliderItemContainer = styled.div``;

export const SliderSectionSubTitle = styled.p`
  ${FONTS.font16}
  color: ${COLORS.blueBlack};
  text-align: center;
  padding-left: 240px;
  padding-right: 240px;
  min-height: 80px;
  height: 100px;

  @media ${BREAKPOINTS.lg} {
    ${FONTS.font14}
  }

  @media ${BREAKPOINTS.md} {
    padding-left: 70px;
    padding-right: 70px;
    min-height: 170px;
  }

  @media ${BREAKPOINTS.sm} {
    ${FONTS.font12}
    padding-left:20px;
    padding-right: 20px;
    min-height: 190px;
  }
`;

export const SliderItemTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  color: ${COLORS.blueBlack};

  @media ${BREAKPOINTS.lg} {
    ${FONTS.font20}
  }

  @media ${BREAKPOINTS.md} {
    ${FONTS.font16}
  }

  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14}
  }
`;

export const SliderItemInfo = styled.p`
  ${FONTS.font24}
  color: ${COLORS.blueBlack};

  @media ${BREAKPOINTS.lg} {
    ${FONTS.font20}
    margin-top:10px;
  }

  @media ${BREAKPOINTS.md} {
    ${FONTS.font16}
    margin-top:12px;
  }

  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14};
  }
`;

export const ContentContainer = styled(BaseContentContainer)`
  ${FLEX_CONTAINER.FlexCenterColumn}
`;

export const CarouselCont = styled.div`
  width: 100%;
  margin-top: 60px;

  .slick-center .slider-active-item {
    transform: scale(1.45);
  }

  @media ${BREAKPOINTS.lg} {
    margin-top: 40px;
  }

  @media ${BREAKPOINTS.md} {
    margin-top: 24px;
  }

  @media ${BREAKPOINTS.sm} {
    margin-top: 16px;
  }

  .carousel {
    margin-bottom: 30px;

    .slick-current {
      img {
        border-radius: 50%;
        transition: all 0.3s;
        border: 4px solid ${COLORS.white};
      }
    }
  }
`;

export const SliderItemTitleBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
`;

export const SliderItemImage = styled.div`
  margin: 60px auto 50px;
  width: 120px;
  height: 120px;
  overflow: hidden;
  border-radius: 100%;
  ${FLEX_CONTAINER.FlexCenterColumn}

  img {
    object-fit: cover;
    transition: all 0.1s;
  }

  @media ${BREAKPOINTS.lg} {
    width: 100px;
    height: 100px;
  }

  @media ${BREAKPOINTS.md} {
    width: 60px;
    height: 60px;
  }

  @media ${BREAKPOINTS.sm} {
    width: 46px;
    height: 46px;
  }
`;

export const CarouselArrow = styled(DefaultButton.Circle)`
  position: absolute;
  transform: translateX(50%);
  top: 290px;
  z-index: 10;
  width: 32px;
  height: 32px;
  background: ${COLORS.mainColor};
  right: ${({ right }) => (right ? '48%' : '52%')};

  :hover {
    background: ${COLORS.mainColor_op7};
    border: none;
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  :active {
    outline: none;
    border: none;
  }

  @media ${BREAKPOINTS.lg} {
    top: 280px;
    right: ${({ right }) => (right ? '47%' : '53%')};
  }

  @media ${BREAKPOINTS.md} {
    width: 24px;
    height: 24px;
    top: 200px;
    right: ${({ right }) => (right ? '46%' : '54%')};
  }

  @media ${BREAKPOINTS.sm} {
    top: 150px;
    right: ${({ right }) => (right ? '44%' : '56%')};
  }

  img {
    width: 10px;
    height: 16px;

    @media ${BREAKPOINTS.lg} {
      width: 8px;
      height: 12px;
    }
  }
`;
